import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';
import { Icon, HtmlParser } from 'components/common';
import './Feature.scss';

const Feature = ({ pro, con, htmlString }) => {
  const classes = {
    feature: true,
    pro,
    con,
  };

  return (
    <div className={classNames(classes)} key={htmlString}>
      <span className="left-icon">
        <Icon name={pro ? 'check' : 'indetermine'} />
      </span>
      <span className="content">
        <HtmlParser htmlString={htmlString} />
      </span>
    </div>
  );
};

Feature.defaultProps = {
  htmlString: null,
  pro: false,
  con: false,
};

Feature.propTypes = {
  htmlString: string,
  pro: bool,
  con: bool,
};

export default Feature;
